module.exports={

  "mobile": [{

    "header_text": "",
    "product_typesx": ["Mobile phone", "Tablet", "Smart Watch", "Galaxy Buds"],
    "product_types": ["Smartphones", "Tablets", "Wearables"],
    "rules_and_placeholders": {
      "mobile_phone": {
        "model_place_holder_text": "E.G. SM-G965F",
        "serial_no_place_holder_text": "E.G. RF8M123KABC",
        "model_no_of_chars": [8],
        "serial_no_of_chars": 11,
        "imei_no_required": true,
        "serial_no_required": false
      },
      "smartphones": {
        "model_place_holder_text": "E.G. SM-G965F",
        "serial_no_place_holder_text": "E.G. RF8M123KABC",
        "model_no_of_chars": [8],
        "serial_no_of_chars": 11,
        "imei_no_required": true,
        "serial_no_required": false
      },
      "tablet": {
        "model_place_holder_text": "E.G. SM-T580F",
        "serial_no_place_holder_text": "E.G. RF8M123KABC",
        "model_no_of_chars": [8],
        "serial_no_of_chars": 11,
        "imei_no_required": false,
        "serial_no_required": true
      },
      "tablets": {
        "model_place_holder_text": "E.G. SM-T580F",
        "serial_no_place_holder_text": "E.G. RF8M123KABC",
        "model_no_of_chars": [8],
        "serial_no_of_chars": 11,
        "imei_no_required": false,
        "serial_no_required": true
      },
      "smart_watch": {
        "model_place_holder_text": "E.G. SM-R815F",
        "serial_no_place_holder_text": "E.G. RF8M123KABC",
        "model_no_of_chars": [8],
        "serial_no_of_chars": 11,
        "imei_no_required": false,
        "serial_no_required": true
      },
      "galaxy_buds": {
        "model_place_holder_text": "E.G. SM-R815F",
        "serial_no_place_holder_text": "E.G. RF8M123KABC",
        "model_no_of_chars": [8],
        "serial_no_of_chars": 11,
        "imei_no_required": false,
        "serial_no_required": true
      },
      "wearables": {
        "model_place_holder_text": "E.G. SM-R815F",
        "serial_no_place_holder_text": "E.G. RF8M123KABC",
        "model_no_of_chars": [8],
        "serial_no_of_chars": 11,
        "imei_no_required": false,
        "serial_no_required": true
      },
    },
    "product_purchase_date_text": "Please note that we cannot arrange a pick-up repair for devices purchased before January 2016.",
    "imei_no_element_req": false,
    "serial_no_required": false,
    "date_of_pruchase_eligible_start_date": "2016-01-01",
    "warranty_confirm_text_3": "If your device is still covered by warranty – You will be required to supply a copy of the device's original proof of purchase (please do not send the original as it cannot be returned). <br />We recommend taking a picture or making a copy of your original and then printing this as a copy. Please secure this copy with your device when collected for repair.",
    "product_conditions": ["Perfect condition", "Slightly scratched", "Heavily scratched", "Physically damaged"],
    "address_label": "Collection and return address",
    "step3_disclaimer_not_used": "Please note, if your device is still covered by warranty you will be required to supply a copy of the device's original proof of purchase (please do not send the original as it cannot be returned). <br / > We recommend making a copy of the original by either; taking a picture and printing; or through use of a photocopier - and then inserting into the box with you product when it is being collected by our logistics partner."



  }],


  "homeappliance": [{

    "header_text": "",
    "product_typesx": ["Washing Machine", "Washer Dryer", "Tumble Dryer", "Oven", "Hob", "Microwave", "Dishwasher", "Refrigerator", "Vacuum Cleaner"],
    "product_types": ["Refrigerator", "Laundry", "Oven", "Hob", "Microwave", "Dishwashers", "Vacuum Cleaners"],
    "product_types_cooking": ["Oven", "Hob", "Microwave"],
    "rules_and_placeholders": {
      "refrigerator": {
        "model_place_holder_text": "E.G. RL58GPEIH1/XEU",
        "serial_no_place_holder_text": "E.G. ABCD1ABC123456A",
        "model_no_of_chars": [14],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },
      "laundry": {
        "model_place_holder_text": "E.G. WW90K5410UX/EU",
        "serial_no_place_holder_text": "E.G. ABCD1ABC123456A",
        "model_no_of_chars": [14],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },
      "oven": {
        "model_place_holder_text": "E.G. NV75R7676RB/EU",
        "serial_no_place_holder_text": "E.G. ABCD1ABC123456A",
        "model_no_of_chars": [13,14],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },
      "hob": {
        "model_place_holder_text": "E.G. C61R2AEE/XEU",
        "serial_no_place_holder_text": "E.G. ABCD1ABC123456A",
        "model_no_of_chars": [12, 14],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },
      "microwave": {
        "model_place_holder_text": "E.G. MC28M6055CK/EU",
        "serial_no_place_holder_text": "E.G. ABCD1ABC123456A",
        "model_no_of_chars": [14],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },
      "dishwashers": {
        "model_place_holder_text": "E.G. DW60M9550FS/EU",
        "serial_no_place_holder_text": "E.G. ABCD1ABC123456A",
        "model_no_of_chars": [14],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },
      "vacuum_cleaners": {
        "model_place_holder_text": "E.G. VC07H40G0VY/EU",
        "serial_no_place_holder_text": "E.G. ABCD1ABC123456A",
        "model_no_of_chars": [14],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },







      "washing_machine": {
        "model_place_holder_text": "E.G. WW90K5410UX/EU",
        "serial_no_place_holder_text": "E.G. ABCD1ABC123456A",
        "model_no_of_chars": [14],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },
      "washer_dryer": {
        "model_place_holder_text": "E.G. WD90J6A10AW/EU",
        "serial_no_place_holder_text": "E.G. ABCD1ABC123456A",
        "model_no_of_chars": [14],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },
      "tumble_dryer": {
        "model_place_holder_text": "E.G. DV90M50003X/EU",
        "serial_no_place_holder_text": "E.G. ABCD1ABC123456A",
        "model_no_of_chars": [14],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },

      "dishwasher": {
        "model_place_holder_text": "E.G. DW60M9550FS/EU",
        "serial_no_place_holder_text": "E.G. ABCD1ABC123456A",
        "model_no_of_chars": [14],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },
      "vacuum_cleaner": {
        "model_place_holder_text": "E.G. VC07H40G0VY/EU",
        "serial_no_place_holder_text": "E.G. ABCD1ABC123456A",
        "model_no_of_chars": [14],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      }

    },
    "product_purchase_date_text": "",
    "imei_no_element_req": false,
    "serial_no_required": true,
    "date_of_pruchase_eligible_start_date": "2015-01-01",
    "warranty_confirm_text_3": "If your device is still covered by warranty, you will be required to show your proof of purchase when the engineer arrives.",
    "product_conditions": ["Yes", "No"],
    "address_label": "Repair address",
    "step3_disclaimer_not_used": "Please note, if your device is still covered by warranty you will be required to show the product's original proof of purchase when the engineer arrives. In some circumstances our Authorised Repair Partner may request a copy in advance of a visit."
  }],
  "tvav": [{
    "header_text": "",
    "product_typesx": ["TV", "Sound Bar", "Blu-Ray"],
    "product_types": ["TV", "Projector", "AV"],
    "rules_and_placeholders": {
      "tv": {
        "model_place_holder_text": "E.G. UE43RU7100KXXU",
        "serial_no_place_holder_text": "E.G. ABCD1ABC123456A",
        "model_no_of_chars": [13,14],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },
      
      "projector": {
        "model_place_holder_text": "E.G. SP-LSP3BLAXXU",
        "serial_no_place_holder_text": "E.G. 4ABC12AB123456A",
        "model_no_of_chars": [13],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },

      "av": {
        "model_place_holder_text": "E.G. HW-N300/XU",
        "serial_no_place_holder_text": "E.G. ABCD1ABC123456A",
        "model_no_of_chars": [10, 11],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },

      "sound_bar": {
        "model_place_holder_text": "E.G. HW-N300/XU",
        "serial_no_place_holder_text": "E.G. ABCD1ABC123456A",
        "model_no_of_chars": [10, 11],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      }
      



    },
    "product_purchase_date_text": "",
    "imei_no_element_req": false,
    "serial_no_required": true,
    "date_of_pruchase_eligible_start_date": "2015-01-01",
    "warranty_confirm_text_3": "If your device is still covered by warranty, you will be required to show your proof of purchase when the engineer arrives.",
    "product_conditions": ["Yes", "No"],
    "address_label": "Repair address",
    "step3_disclaimer_not_used": "Please note, if your device is still covered by warranty you will be required to show the product's original proof of purchase when the engineer arrives. In some circumstances our Authorised Repair Partner may request a copy in advance of a visit."
  }],


  "monitoroffice": [{

    "header_text": "",
    "product_types": ["Monitor", "Galaxy Book"],
    "rules_and_placeholders": {

      "monitor": {
        "model_place_holder_text": "E.G. LC27FG73FQUXEN",
        "serial_no_place_holder_text": "E.G.  ABCD1ABC123456A",
        "model_no_of_chars": [13, 14],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },
      "galaxy_book": {
        "model_place_holder_text": "E.G. SM-W728NZKABTU",
        "serial_no_place_holder_text": "E.G.  12ABC12A12345AB",
        "model_no_of_chars": [14],
        "serial_no_of_chars": 15,
        "imei_no_required": false,
        "serial_no_required": true
      },


    },
    "product_purchase_date_text": "",
    "imei_no_element_req": false,
    "serial_no_required": true,
    "date_of_pruchase_eligible_start_date": "2015-01-01",
    "warranty_confirm_text_3": "If your device is still covered by warranty you will be required to supply a copy of the device’s original proof of purchase (please do not send the original as it cannot be returned). We recommend taking a picture or making a copy of your original and then printing this as a copy. Please secure this copy with your device when collected for repair.",
    "product_conditions": ["Perfect condition", "Slightly scratched", "Heavily scratched", "Physically damaged"],
    "address_label": "Collection and return address",
    "step3_disclaimer_not_used": "Please note, if your device is still covered by warranty you will be required to supply a copy of the device's original proof of purchase (please do not send the original as it cannot be returned). <br / > We recommend making a copy of the original by either; taking a picture and printing; or through use of a photocopier - and then inserting into the box with you product when it is being collected by our logistics partner."
  }]

}